// import $ from 'jquery';
// import Swiper from 'swiper';
// import {Navigation, Pagination, EffectFade, Controller} from 'swiper/modules';

export default (function () {
  var albumLoading = false;
  $('.album__item').each(function () {
    $(this).click(function (e) {
      e.preventDefault();
      $(this).parents('.album').find('.album-modal').remove();
      if (!albumLoading) {
        loadAlbumGalerie($(this));
      }
    });
  });
  $(document).on('click', '.album-modal', function (e) {
    if ($(e.target).hasClass("container") || $(e.target).hasClass("album-modal__overlay") || $(e.target).hasClass("album-modal__close")) {
      $(this).fadeOut();
    }
  });
  function loadAlbumGalerie(el) {
    var albumId = el.data('id');
    var albumWrapp = el.parents('.album');
    albumLoading = true;
    $.ajax({
      url: myajax.url,
      dataType: 'json',
      method: 'POST',
      data: {
        action: 'get_album_galerie',
        album_id: albumId
      },
      beforeSend: function beforeSend() {
        el.addClass('loading');
      },
      success: function success(data) {
        albumWrapp.append($(data.content));
        el.removeClass('loading');
        albumWrapp.find('.album-modal').fadeIn();
        initAlbumSlider();
      },
      complete: function complete() {
        albumLoading = false;
      }
    });
  }
  function initAlbumSlider() {
    var albumSliderImage = new Swiper('.album-slider', {
      // modules: [Navigation, Controller, EffectFade],
      spaceBetween: 15,
      centeredSlides: true,
      loop: false,
      effect: "slide",
      slidesPerView: 1.2,
      watchOverflow: true,
      navigation: {
        nextEl: '.album-slider-button-next',
        prevEl: '.album-slider-button-prev'
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 0
        }
      }
    });
    var albumSliderCaption = new Swiper('.album-caption', {
      // modules: [EffectFade, Pagination],
      spaceBetween: 0,
      centeredSlides: true,
      effect: "fade",
      loop: false,
      slidesPerView: 1,
      watchOverflow: true,
      pagination: {
        el: ".album-slider-pagination",
        type: "fraction"
      }
    });
    albumSliderImage.controller.control = albumSliderCaption;
  }
});